import React from 'react';

interface CodeIconProps {
    className?: string;
}

const CodeIcon: React.FC<CodeIconProps> = ({ className = "w-4 h-4" }) => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" className={className}>
        <polyline points="8 4 3 12 8 20"></polyline>
        <polyline points="16 4 21 12 16 20"></polyline>
    </svg>
);

export default CodeIcon;
